import { Select, SelectContent, SelectGroup, SelectItem, SelectLabel, SelectTrigger, SelectValue } from '../ui/select';
import { ArrowsDownUpIcon } from '@phosphor-icons/react';

const TestListingSort = ({ selectedSortOption, setSelectedSortOption }) => {
  const handleValueChange = (value) => {
    setSelectedSortOption(value);
  };

  return (
    <Select value={selectedSortOption || ''} onValueChange={handleValueChange}>
      <SelectTrigger
        className={`rounded-full !bg-[var(--q3-surface-default)] shadow-none flex items-center gap-2 px-4 py-2  text-[var(--q3-neutral-default)] transition-colors w-auto cursor-pointer`}
      >
        <ArrowsDownUpIcon className="h-4 w-4 text-[var(--q3-neutral-default)]" />
        <SelectValue placeholder="Sort by" />
      </SelectTrigger>

      <SelectContent>
        <SelectGroup>
          <SelectItem value="release_date">Release Date</SelectItem>
          <SelectItem value="attempt_date">Attempt Date</SelectItem>
          <SelectItem value="score">Score</SelectItem>
          <SelectItem value="accuracy">Accuracy</SelectItem>
        </SelectGroup>
      </SelectContent>
    </Select>
  );
};

export default TestListingSort;
